module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"send":"Send","friend":"In your friend list","subscribed":"You are subscribed","add":"Add to friends","follow":"Subscribe","nothing":"Nothing found","mes":"Send message"},"ru":{"send":"Отправить","friend":"В друзьях","subscribed":"Вы подписаны","add":"Добавить в друзья","follow":"Добавить в друзья","nothing":"Ничего не найдено","mes":"Отправить сообщение"}}')
  delete Component.options._Ctor
}
